<!-- Button für Messgrössen -->
<!--Copy right - © 2024 tecera gmbh-->

<script>
    import {
        selected_device,
        chart,
        extended_device_channel_list,
    } from "../../stores.js";
    import {
        user_role
    } from "../../scripts/auth.js";
    import { onDestroy, onMount } from "svelte";
    export let chart_data = null;
    export let multiple_devices = false;
    export let is_disabled = false;

    let is_open = false;

    onMount(() => {
        const handleClickOutside = (event) => {
            if (is_open && !event.target.closest(".dropdown")) {
                is_open = false;
            }
        };

        document.addEventListener("click", handleClickOutside);

        return () => {
            document.removeEventListener("click", handleClickOutside);
        };
    });

    function toggle_channel(checked, channel) {
        let index;
        let channel_id = channel.channel_id;
        if (chart_data && chart_data.length > 0) {
            if (channel_id) {
                chart_data.forEach((data) => {
                    if (channel_id && channel_id == data.channel_id) {
                        data.visible = checked;
                        return;
                    }
                });
            } else {
                chart_data[index].visible = checked;
            }
            chart_data = chart_data;
        }

        $extended_device_channel_list = $extended_device_channel_list.map(
            (element) => {
                if (element.channel_id == channel_id) {
                    element.visible = checked;
                }
                return element;
            },
        );

        if ($chart) {
            index = $chart.series.findIndex((element) => {
                return element.userOptions.channel_id == channel_id;
            });
            if (index === -1) {
                return;
            }
            channel_id = index;
            if (multiple_devices) {
                // Get the measurand of the current series
                let currentMeasurand = $chart.series[index].options.measurand;

                // Find the first visible axis with the same measurand
                let visibleAxisIndex = $chart.yAxis.findIndex(
                    (axis, axisIndex) =>
                        axisIndex !== index && // Exclude the current axis
                        axis.visible &&
                        axis.options.measurand === currentMeasurand,
                );
                let actual_index = checked
                    ? index < visibleAxisIndex || visibleAxisIndex == -1
                        ? index
                        : visibleAxisIndex
                    : visibleAxisIndex;

                // Get all series with the same measurand
                let sameMeasurandSeries = $chart.series.filter(
                    (series) =>
                        series.options.measurand === currentMeasurand &&
                        series.name !== "Navigator 1",
                );

                // Update each series to use the found visible axis
                if (actual_index !== -1) {
                    sameMeasurandSeries.forEach((series) =>
                        series.update({ yAxis: actual_index }),
                    );
                }
            }

            $chart.series[index].setVisible(checked);
            $chart.yAxis[index].update({ visible: checked });
        }
    }

    $: {
        if (($selected_device && $selected_device.box_id) || $user_role["filter_measurands"] != 0) {
            is_disabled = true;
        } else {
            is_disabled = false;
        }
    }
</script>

<div class="dropdown btn-distance">
    <button
        class="btn btn-primary dropdown-toggle {is_disabled ? 'disabled' : ''}"
        id="dropdownMessgroesse"
        type="button"
        aria-haspopup="true"
        on:click={() => (is_open = !is_open)}
    >
    <i class="fa-solid fa-ruler"></i>&nbsp;&nbsp;<span class="messgroesse-text">Messgrösse&nbsp;</span>
    </button>

    {#if !is_disabled && $extended_device_channel_list && $extended_device_channel_list.length > 0}
        <div
            class="dropdown-menu filter_dropdown mt-2 {is_open ? 'show' : ''}"
            aria-labelledby="dropdownMessgroesse"
        >
            <div class="filter_dropdown_scrollable" id="select_Felder">
                {#each $extended_device_channel_list as channel (channel.channel_id)}
                    <label class="dropdown__checkbox">
                        <input
                            type="checkbox"
                            class="messgroesse hide-title"
                            checked={channel.visible}
                            id="Channel - {channel.channel_id}"
                            on:click={(e) => {
                                toggle_channel(e.target.checked, channel);
                            }}
                        />
                        {channel.display_name}
                    </label>
                {/each}
            </div>
        </div>
    {/if}
</div>
